import { IndexEventsResponse } from './IndexEventsResponse';

export type ValidateResponse = {
    isValid: boolean;
    error?: { message: string; data: unknown };
};
const fail: (message: string, data?: unknown) => ValidateResponse = (
    message,
    data
) => ({
    isValid: false,
    error: { message, data },
});

export function validateResponse(
    response: IndexEventsResponse
): ValidateResponse {
    if (!response.indexRebalEvents) {
        return fail('No "indexRebalEvents" in response', response);
    }

    return { isValid: true };
}
